var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',[(_vm.isCancelByCourse())?_c('CourseTable'):_c('BlockSequenceTable')],1)],1),_c('b-col',[_c('b-card',[(_vm.isCancelByCourse())?_c('CourseTripsTable'):_c('TripsTable')],1)],1),_c('b-col',[_c('b-card',[_c('PassingtimesTable')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }